import {
  Rotationsplan_StandortgruppeByIdQuery,
  Rotationsplan_StandortgruppeByIdQueryVariables,
} from '@/gql/graphql';
import { useSuspenseQuery } from '@apollo/client';
import * as Sentry from '@sentry/react';
import { Standortgruppe } from '@/domain/mitarbeiter/features/rotationsplan/entities/standortgruppe';
import { STANDORTGRUPPE_BY_ID } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useStandortgruppen/graphql/queries';

export function useStandortgruppe(standortGruppenId: string): {
  standortGruppe: Standortgruppe | undefined;
  error?: string;
} {
  const result = useSuspenseQuery<
    Rotationsplan_StandortgruppeByIdQuery,
    Rotationsplan_StandortgruppeByIdQueryVariables
  >(STANDORTGRUPPE_BY_ID, {
    variables: { standortGruppenId },
  });

  if (result.error) {
    Sentry.captureException(result.error);
    return { standortGruppe: undefined };
  }

  return {
    standortGruppe: new Standortgruppe({
      id: result.data.mitarbeiter_standortgruppeById.id,
      istRotationsplanAktiviert:
        result.data.mitarbeiter_standortgruppeById.rotationsplanEinstellungen
          ?.istRotationsplanAktiviert,
    }),
  };
}
